var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4716 4.02861C12.7319 4.28896 12.7319 4.71107 12.4716 4.97141L4.47157 12.9714C4.21122 13.2318 3.78911 13.2318 3.52876 12.9714C3.26841 12.7111 3.26841 12.289 3.52876 12.0286L11.5288 4.02861C11.7891 3.76826 12.2112 3.76826 12.4716 4.02861Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52876 4.02861C3.78911 3.76826 4.21122 3.76826 4.47157 4.02861L12.4716 12.0286C12.7319 12.289 12.7319 12.7111 12.4716 12.9714C12.2112 13.2318 11.7891 13.2318 11.5288 12.9714L3.52876 4.97141C3.26841 4.71107 3.26841 4.28896 3.52876 4.02861Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cb2ab85a3a054eace13ed08cda431bec.svg";
export { ForwardRef as ReactComponent };